
//Local
/*export const oidcSettings= {
  authority: 'https://login.microsoftonline.com/132b9871-e025-4ead-a34d-7bd5e7a383b4/v2.0',
  clientId: '6358990a-1286-4086-bf5f-486e97c81f44',
  redirectUri: 'https://localhost:8080/oidc-callback',
  responseType: 'code',
  scope: 'openid profile email offline_access',
  automaticSilentRenew: true,
  silentRedirectUri: 'https://localhost:8080/silent-renew-oidc.html',
  automaticSilentSignin: false
}*/

//desarrollo
/*export const oidcSettings= {
  authority: 'https://login.microsoftonline.com/132b9871-e025-4ead-a34d-7bd5e7a383b4/v2.0',
  clientId: '30e85997-b514-4578-a8d2-fab07d42df1f',
  redirectUri: 'https://www.colmena.ugto.mx/Transparencia/oidc-callback',
  responseType: 'code',
  scope: 'openid profile email offline_access',
  automaticSilentRenew: true,
  silentRedirectUri: 'https://www.colmena.ugto.mx/Transparencia/silent-renew-oidc.html',
  automaticSilentSignin: false
}*/

//Produccion
export const oidcSettings = {
  authority: 'https://login.microsoftonline.com/132b9871-e025-4ead-a34d-7bd5e7a383b4/v2.0',
  clientId: '30e85997-b514-4578-a8d2-fab07d42df1f',
     redirectUri: 'https://intranet3.ugto.mx/Transparencia/oidc-callback',
     responseType: 'code',
     scope: 'openid profile email offline_access',
     automaticSilentRenew: true,
     silentRedirectUri: 'https://intranet3.ugto.mx/Transparencia/silent-renew-oidc.html',
     automaticSilentSignin: false
  }